import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import fetchOAuth from './useOAuth.request';
import { OAuthData } from './useOAuth.interface';

export const OAUTH_QUERY_KEY = ['oauth', 'useOAuth'];

const useOAuth = (options?: Omit<UseQueryOptions<OAuthData>, 'queryKey'>) => {
    return useQuery<OAuthData>({
        queryKey: OAUTH_QUERY_KEY,
        queryFn: fetchOAuth,
        refetchOnWindowFocus: false,
        staleTime: 5000 * 60, // 5 minutes
        ...options,
    });
};

export default useOAuth;
